import { reactive } from "vue";
import { decodeJwt, rolesFromPayload } from "../jwt.js";
export class DemoAuthProvider {
    name = "demo";
    state;
    loginUri;
    storageKey;
    constructor(opts) {
        this.loginUri = resolveLoginUri(opts.loginUri, opts.apiUrl);
        this.storageKey = opts.storageKey;
        this.state = reactive({
            status: "idle",
            user: null,
            idToken: null,
            accessToken: null,
            error: null,
        });
    }
    async init() {
        this.state.status = "initializing";
        const token = sessionStorage.getItem(this.storageKey);
        const user = token ? this.userFromToken(token) : null;
        if (token && user) {
            this.state.user = user;
            this.state.idToken = null;
            this.state.accessToken = token;
            this.state.status = "authenticated";
            return;
        }
        sessionStorage.removeItem(this.storageKey);
        this.clearState("unauthenticated");
    }
    async login(_provider, _redirectTo, credentials) {
        if (!credentials?.password) {
            this.state.status = "error";
            this.state.error = "A demo password is required.";
            return;
        }
        this.state.status = "initializing";
        this.state.error = null;
        try {
            const response = await fetch(this.loginUri, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ password: credentials.password }),
            });
            if (!response.ok) {
                throw new Error(response.status === 401 ? "Invalid demo password." : "Demo login failed.");
            }
            const body = (await response.json());
            if (typeof body.accessToken !== "string") {
                throw new Error("Demo login did not return an access token.");
            }
            const user = this.userFromToken(body.accessToken);
            if (!user) {
                throw new Error("Demo login returned an invalid access token.");
            }
            sessionStorage.setItem(this.storageKey, body.accessToken);
            this.state.user = user;
            this.state.idToken = null;
            this.state.accessToken = body.accessToken;
            this.state.status = "authenticated";
            this.state.error = null;
        }
        catch (error) {
            this.clearState("error");
            this.state.error = error instanceof Error ? error.message : "Demo login failed.";
        }
    }
    async logout() {
        sessionStorage.removeItem(this.storageKey);
        this.clearState("unauthenticated");
    }
    userFromToken(token) {
        const payload = decodeJwt(token);
        if (!payload || payload.exp * 1000 <= Date.now())
            return null;
        return {
            id: payload.sub,
            email: payload.email,
            name: payload.name,
            roles: rolesFromPayload(payload),
        };
    }
    clearState(status) {
        this.state.user = null;
        this.state.idToken = null;
        this.state.accessToken = null;
        this.state.error = null;
        this.state.status = status;
    }
}
function resolveLoginUri(loginUri, apiUrl) {
    if (!apiUrl || /^[a-z][a-z\d+\-.]*:/i.test(loginUri)) {
        return loginUri;
    }
    return new URL(loginUri.replace(/^\/+/, ""), apiUrl.endsWith("/") ? apiUrl : `${apiUrl}/`).toString();
}
//# sourceMappingURL=demo.js.map